document.querySelectorAll('.mix-match-block').forEach((block) => {
  block.querySelectorAll('.mix-match-selected').forEach((selected) => {
    const optionsContainer = selected.closest('.mix-match-select-box').querySelector('.mix-match-options-container');
    selected.addEventListener('click', (event) => {
      optionsContainer.classList.toggle('active');
      event.stopPropagation();
    });
    optionsContainer.querySelectorAll('.mix-match-option').forEach((option) => {
      option.addEventListener('click', () => {
        selected.innerHTML = option.querySelector('label').innerHTML;
        optionsContainer.classList.remove('active');
        optionsContainer.classList.add('valueadded');
      });
    });
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.mix-match-options-container').forEach((optionsContainer) => {
    if (!optionsContainer.closest('.mix-match-select-box').contains(event.target)) {
      optionsContainer.classList.remove('active');
    }
  });
});
document.querySelectorAll('.inner_select').forEach(function (element) {
  element.addEventListener('click', function (event) {
    const prohandle = event.target.getAttribute('data-prohandle');
    const parent = event.target.closest('.mix-match-select-block');
    const mainparent = event.target.closest('.mix-match-block');
    parent.querySelector('.mix-match-selected p').innerHTML = event.target.getAttribute('data-prooption');
    if (prohandle) {
      if (document.querySelectorAll('.mix-match-block .mixmatchids_' + prohandle).length > 0) {
        document.querySelectorAll('.mix-match-block .mixmatchids_' + prohandle).forEach(function (mixmatchBlock) {
          mixmatchBlock.classList.remove('mixids');
        });
        event.target.closest('.mix-match-block').querySelector('.soldout').classList.add('hide');
        if (parent.querySelector('input[type="radio"]:checked')) {
          parent.querySelector('input[type="radio"]:checked').checked = false;
        }
      }
    }
    event.target.closest('.mix-match-options-container').classList.remove('active');
    if (document.getElementsByClassName('mixids').length == 0) {
      document.querySelector('.mix-match-block-submit-button button').setAttribute('disabled', 'disabled');
    }
    mainparent.querySelectorAll('.mix-match-selected p').forEach(function (selectedElement) {
      const allIncludeSelect = Array.from(mainparent.querySelectorAll('.mix-match-selected p')).every((element) =>
        element.innerHTML.includes('Select')
      );
      if (allIncludeSelect) {
        event.target.closest('.mix-match-block').querySelector('.option-error').classList.add('hide');
      } else {
        event.target.closest('.mix-match-block').querySelector('.option-error').classList.remove('hide');
        document.querySelector('.mix-match-block-submit-button button').setAttribute('disabled', 'disabled');
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const addToCartButton = document.getElementById('addToCartButton_mixmatch');
  addToCartButton.addEventListener('click', function () {
    addToCartButton.setAttribute('disabled', 'disabled');
    addToCartButton.innerHTML = '';
    document.querySelector('.buy_buttons_text .loading__spinner').classList.remove('hidden');
    const variantIds = Array.from(document.getElementsByClassName('mixids')).map(function (input) {
      return input.value;
    });

    function addToCart(variantId, callback) {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            if (callback) callback();
          } else {
            if (callback) callback(new Error(xhr.responseText));
          }
        }
      };
      const data = {
        id: variantId,
        quantity: 1,
        properties: {
          colour: document.querySelector('.color_property').value
        }
      };
      xhr.send(JSON.stringify(data));
    }

    function addAllToCart(variantIds, callback) {
      if (variantIds.length === 0) {
        if (callback) callback();
        return;
      }
      const currentId = variantIds.shift();
      addToCart(currentId, function (error) {
        if (error) {
          return;
        }
        addAllToCart(variantIds, callback);
      });
    }

    function updateCartUI() {
      fetch('/cart.json')
        .then((response) => response.json())
        .then((cart) => {
          fetch(routes.cart_url + '?section_id=cart-drawer&_=' + Date.now())
            .then((response) => response.text())
            .then((text) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');

              // #CartDrawer lives inside a <template> in the section response —
              // must traverse template.content to find it.
              let sourceCartDrawer = doc.getElementById('CartDrawer');
              if (!sourceCartDrawer) {
                const tmpl = doc.querySelector('template');
                if (tmpl) sourceCartDrawer = tmpl.content.getElementById('CartDrawer');
              }

              // Hydrate the live cart-drawer so #CartDrawer exists in the live DOM.
              const cartDrawerEl = document.querySelector('cart-drawer');
              if (cartDrawerEl && typeof cartDrawerEl.hydrate === 'function') {
                cartDrawerEl.hydrate();
              }

              const liveCartDrawer = document.getElementById('CartDrawer');

              if (sourceCartDrawer && liveCartDrawer) {
                liveCartDrawer.innerHTML = sourceCartDrawer.innerHTML;
              }

              if (cartDrawerEl) {
                cartDrawerEl.classList.remove('is-empty');
              }

              const cartDrawerItems = document.querySelector('cart-drawer-items');
              if (cartDrawerItems) {
                cartDrawerItems.classList.remove('is-empty');
              }

              // Update cart count bubble
              const cartIconBubble = document.getElementById('cart-icon-bubble');
              if (cartIconBubble) {
                let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
                if (!cartCountBubble) {
                  const cartNumber = document.createElement('div');
                  cartNumber.className = 'cart-count-bubble';
                  cartNumber.innerHTML = `
                    <span aria-hidden="true">${cart.item_count}</span>
                    <span class="visually-hidden">${cart.item_count} items</span>
                  `;
                  cartIconBubble.appendChild(cartNumber);
                } else {
                  const visibleSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
                  if (visibleSpan) visibleSpan.textContent = cart.item_count;
                }
              }

              // Re-bind overlay close handler (the DOM was replaced above)
              const overlay = document.getElementById('CartDrawer-Overlay');
              if (overlay) {
                overlay.addEventListener('click', function () {
                  if (cartDrawerEl) cartDrawerEl.close();
                });
              }
            });
        });
    }
    addAllToCart(variantIds, function () {
      updateCartUI();
      setTimeout(function () {
        document.querySelector('.buy_buttons_text .loading__spinner').classList.add('hidden');
        addToCartButton.removeAttribute('disabled');
        addToCartButton.innerHTML = addToCartButton.getAttribute('data-btntext');
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.click();
        }
      }, 1000);
    });
  });
});
document.querySelectorAll('.mix-match-swatch input').forEach((input) => {
  input.addEventListener('click', function () {
    const parentSelect = this.closest('.mix-match-select');
    parentSelect.querySelector('.color_opt').innerHTML = ' ' + this.value;
    if (parentSelect) {
      const selectedElement = parentSelect.querySelector('.mix-match-selected.' + this.getAttribute('data-optionname'));
      const optionElement = parentSelect.querySelector(
        '.mix-match-option.' + this.getAttribute('data-optionname') + ' input[value="' + this.value + '"]'
      );
      if (selectedElement) {
        selectedElement.click();
      }
      if (optionElement) {
        optionElement.click();
      }
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const mixMatchSelectBoxes = document.querySelectorAll('.mix-match-select-box .mixmatchradio');

  mixMatchSelectBoxes.forEach(function (radio) {
    radio.addEventListener('change', function () {
      const parentBlock = radio.closest('.mix-match-block');
      const submitButton = document.querySelector('.mix-match-block-submit-button button');
      const allSelectBoxes = parentBlock.querySelectorAll('.mix-match-select-box');
      const allSelected = Array.from(allSelectBoxes).every((selectBox) => {
        const selectedOption = selectBox.querySelector('.mixmatchradio:checked');
        return !!selectedOption;
      });

      if (allSelected) {
        const selectedValues = [];
        allSelectBoxes.forEach(function (selectBox) {
          const selectedOption = selectBox.querySelector('.mixmatchradio:checked');
          selectedValues.push(selectedOption.value);
        });
        const concatenatedValues = selectedValues.join(' / ');

        const matchedVariant = Array.from(parentBlock.querySelectorAll('.variants_mixmatch')).filter(
          function (variant) {
            return variant.value === concatenatedValues;
          }
        );
        if (matchedVariant.length > 0) {
          const variant = matchedVariant[0];
          const variantAvailable = variant.dataset.available === 'true';
          const prodHandle = variant.dataset.handle;
          const mixmatchIdElement = document.querySelector('.mixmatchids_' + prodHandle);
          const mixmatchPriceElement = document.querySelector('.mixmatchprice_' + prodHandle);

          if (variantAvailable) {
            submitButton.removeAttribute('disabled');
            if (mixmatchIdElement) {
              mixmatchIdElement.value = variant.dataset.variantid;
              mixmatchIdElement.classList.add('mixids');
            }
            parentBlock.querySelector('.soldout').classList.add('hide');
          } else {
            submitButton.setAttribute('disabled', 'disabled');
            if (mixmatchIdElement) {
              mixmatchIdElement.value = '';
              mixmatchIdElement.classList.remove('mixids');
            }
            parentBlock.querySelector('.soldout').classList.remove('hide');
          }

          if (mixmatchPriceElement) {
            mixmatchPriceElement.innerHTML = variant.dataset.price;
          }
        } else {
          parentBlock.querySelector('.soldout').classList.remove('hide');
          submitButton.setAttribute('disabled', 'disabled');
        }
        parentBlock.querySelector('.option-error').classList.add('hide');
      } else {
        parentBlock.querySelector('.option-error').classList.remove('hide');
      }
      let allHaveClass = true;
      const elements = document.querySelectorAll('.option-error, .soldouterror');
      elements.forEach(function (element) {
        if (!element.classList.contains('hide')) {
          allHaveClass = false;
          submitButton.setAttribute('disabled', 'disabled');
        }
      });
      if (allHaveClass) {
        submitButton.removeAttribute('disabled');
      }
    });
  });
});

function updateCrossOutOptions(productId, parentBlock) {
  const radios = [...parentBlock.querySelectorAll('.mixmatchradio')];
  const selectedOptions = {};

  radios
    .filter((radio) => radio.checked)
    .forEach((radio) => {
      selectedOptions[radio.getAttribute('data-opname')] = radio.value;
    });

  const allOptionNames = Array.from(radios)
    .map((r) => r.getAttribute('data-opname'))
    .filter((v, i, self) => self.indexOf(v) === i);

  radios.forEach((radio) => {
    radio.classList.remove('cross-out');

    const tempSelected = { ...selectedOptions, [radio.getAttribute('data-opname')]: radio.value };
    const matchExists = productVariants[productId].some((variant) => {
      return allOptionNames.every((optionName) => {
        return !tempSelected[optionName] || variant.options.includes(tempSelected[optionName]);
      });
    });

    if (!matchExists) {
      radio.classList.add('cross-out');
    }
  });
}

document.querySelectorAll('.mixmatchradio').forEach((radio) => {
  radio.addEventListener('change', () => {
    updateCrossOutOptions(radio.getAttribute('data-proid'), radio.closest('.mix-match-block'));
  });
});
